/* eslint-disable max-len */
/* eslint-disable camelcase */
export const order_manage = {
    payment_success_message: 'Заказ успешно оплачен',
    payment_fail_message: 'Оплатить заказ не удалось'
};
